import { styled } from "twin.macro"
import FloatingBoxWrapper from "../../atoms/floating-box"
import { cycleStyles } from "../../../utils/style-helpers"

const styles = {
  base: [{}, { z: 20 }],
  sm: [
    {
      w: "45%",
    },
    {
      w: "55%",
    },
    {
      w: ["25%", "35%"],
    },
  ],
  xl: [
    {
      w: "32%",
    },
    {
      w: "44%",
    },
    {
      w: "22%",
    },
    {
      w: "22%",
    },
  ],
}

const WaterfallMediaSizer = styled(FloatingBoxWrapper)(
  ({ index, isPortrait }) => {
    return [
      `
      ${cycleStyles(styles.base, index, isPortrait)}
      width: var(--ft-w, 80%);
      z-index: var(--ft-z, 0);
      position: relative;
      &:hover {
        z-index: 40;
      }
    @media (min-width: 640px) {
      ${cycleStyles(styles.sm, index, isPortrait)}
    }
    @media (min-width: 1280px) {
      ${cycleStyles(styles.xl, index, isPortrait)}
    }
    `,
    ]
  }
)

export default WaterfallMediaSizer
